function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import CardTitle from "./CardTitle";

function Card(_ref) {
  var title = _ref.title,
      children = _ref.children,
      className = _ref.className,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? defaultVariant : _ref$variant,
      props = _objectWithoutProperties(_ref, ["title", "children", "className", "variant"]);

  return React.createElement(StyledCard, _extends({
    className: className,
    variant: variant
  }, props), title && React.createElement(CardTitle, {
    className: "cardTitle",
    gutterBottom: true
  }, title), React.createElement("div", {
    className: "cardChildren"
  }, children));
}

export var StyledCard = styled.div.withConfig({
  displayName: "Card__StyledCard",
  componentId: "af3nwr-0"
})(["background-color:", ";border:1px solid ", ";border-top:1px solid ", ";padding:0.75rem 1rem;margin:0.75rem 0.5rem;box-sizing:border-box;display:flex;flex-direction:column;.cardChildren{flex-grow:1;}"], function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.greyAdobe1;
}, function (props) {
  return props.variant === defaultVariant ? props.theme.primaryColor : props.theme.greyAdobe1;
});
var variants = ["primary", "secondary"];
var defaultVariant = "primary";
Card.propTypes = {
  variant: PropTypes.oneOf(variants),

  /**
   * Title of the card, wrapped in a Typography component.
   */
  title: PropTypes.string,

  /**
   * Children passed to the Card.
   * "PropTypes.node" is any type that can be rendered, ie, string, number etc
   */
  children: PropTypes.node,

  /**
   * Classname that is passed to the card.
   */
  className: PropTypes.string
};
export default Card;